var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButtonRound',{attrs:{"btn_type":_vm.active?'btn-default':'btn-info'},on:{"click":_vm.click}},[_c('template',{slot:"content"},[_c('i',{staticClass:"material-icons"},[_vm._v("info")])])],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4df83e2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Shared/Resources/Assets/js/components/buttons/InfoButton.vue
// module id = op3a
// module chunks = 0